import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit/types/TDeviceType';

export function trackShow(id: number, deviceType: TDeviceType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentReviews',
    action: 'show',
    label: 'Write_Open_Screen2',
    page: {
      pageType: 'ReviewsDailyrent',
      siteType: deviceType === 'desktop' ? 'desktop' : 'mobile',
    },
    products: [{ id, offerType: 'offer' }],
  });
}
